import { useState } from "react";

interface Props {
  page: number;
  size: number;
}

interface ReturnedData {
  page: number;
  setPage: (pageNumber: number) => void;
  size: number;
  setSize: (pageSize: number) => void;
}

export const usePagination = (props: Props): ReturnedData => {
  const { page, size } = props;
  const [currentNumber, setCurrentNumber] = useState<number>(page);
  const [currentSize, setCurrentSize] = useState<number>(size);

  return {
    page: currentNumber,
    setPage: (pageNumber) => {
      setCurrentNumber(pageNumber);
    },
    size: currentSize,
    setSize: (pageSize) => {
      setCurrentSize(pageSize);
    },
  };
};
